import { Component, inject } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';
import { SHARED_IMPORTS } from '../../shared-imports';

@Component({
  selector: 'syn-navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrls: ['./navigation-bar.component.scss'],
  imports: [SHARED_IMPORTS],
})
export class NavigationBarComponent {
  private readonly _keycloak = inject(KeycloakService);

  isCollapsed = true;

  logOut() {
    this._keycloak.logout(environment.settings.manager.website.url);
  }
}
